import { ReactNode } from 'react'

import styles from './NavigationBadge.module.css'

const NavigationBadge = ({ children }: { children: ReactNode }) => (
    <div
        data-component="navigation-badge"
        className={styles.navigationBadge}
        aria-live="polite"
    >
        {children}
    </div>
)

export default NavigationBadge
